module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAYAAADJViUEAAAAzklEQVQokcXSP0oDQRQH4C9rCgOypIyttZDGRpuE4AW28QKChbB32C6dEBc8gaWwTTpziXQxCJZpFGFrC4tEWAY25k+RHwzMvPe+YphpZFmmLkWcXuIZLdwlZT6u9qNauUyGM5ziMWzW4iJOj3BVKR1vjNHDSeX8vhEu4rSDp6A8C+ca3Yeve/QhKfObIk5fcYF2MDvFfLX/wLCJEZqVoeuaa3RX6y/nUQC3yeC/p1qXxT54tg+eHwy/7Yp/MN0VvyRl/hlhsgX6tvy2t/ALfiEkwiOpiSkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/fabulous_curr.png
// module id = 4gWC
// module chunks = 0